import { Linked, useModel, useIO, useCollection } from '@type-r/react';
import * as React from 'react';
import { InvoiceModel } from 'api/invoice';
import { CompactTextArea, PopupIODialog, FormSelect, Option, FormInput, Loading } from 'lqx-react';
import { localUserInfo } from 'api';
import { attributes, Events } from '@type-r/models';
import { Activity } from "api/activity";

const InternalInvoiceStatus = attributes({
    id: Number,
    internalStatus: String,
    statusDescription: String,
    companyId: String,
});

const LocalState = attributes({
    comment: String,
    internalStatusId: String,
    internalStatus: String,
    internalStatusDescription: String
});

export const InternalStatusDialog = ({
    $isOpen,
    invoice,
}: {
    $isOpen: Linked<boolean>,
    invoice: InvoiceModel,
}) => {
    let state = useModel(LocalState);
    let statuses = useCollection.of(InternalInvoiceStatus);
    const invoiceCommentActivity = useModel(Activity);

    React.useEffect(() => {
        invoiceCommentActivity.$.type.set('InvoiceInternalStatus');
    }, []);

    const isReady = useIO(async () => {
        let res = await InvoiceModel.getInternalStatusesByCompany(invoice.relationship.id);
        statuses.set(res);
    }, []);

    const getInternalDescription = (internalStatusId) => {
        let statusDescription = '';
        if (internalStatusId) {
            statusDescription = statuses.find(i => i.id == internalStatusId).statusDescription;
            state.internalStatusDescription = statusDescription;
        }
        return statusDescription;
    }

    const savePopupInfo = async () => {
        await saveInternalStatus();
        await saveComment();
    };

    const saveInternalStatus = async () => {
        await invoice.saveInternalInvoiceStatuses({
            id: state.internalStatusId,
            invoiceId: invoice.id
        });
    };

    const saveComment = async () => {
        const activity = invoiceCommentActivity.clone();
        activity.type = "InvoiceInternalStatus"
        activity.assetId = invoice.id;
        activity.relationshipId = localUserInfo.getRelationshipId(invoice.conversationId);

        await Activity.saveActivities(Array.from([activity]), 'Invoice');
    }

    return (
        <PopupIODialog
            $isOpen={$isOpen}
            title={"SET INTERNAL STATUS"}
            actionLabel={"Save"}
            success={"Internal status saved successfully"}
            onSuccess={() => Events.trigger("Invoice:close")}
            doIO={savePopupInfo}
            disabled={!state.internalStatusId}
        >
            <>
                {isReady ?
                    <>
                        {statuses.length > 0 ?
                            <>
                                <FormSelect label="Internal status" $value={state.$.internalStatusId}>
                                    {statuses.map(sr => <Option key={sr.id} value={sr.id}>{sr.internalStatus}</Option>)}
                                </FormSelect>
                                <FormInput label="Internal Description" value={getInternalDescription(state.internalStatusId)} />
                                <CompactTextArea label="Comments" $value={invoiceCommentActivity.$.comment} />
                            </> :
                            <div>There is no internal statuses available for this invoice</div>
                        }
                    </>
                    : <Loading />
                }
            </>
        </PopupIODialog>
    );
}
